import { CHAIN, UNIT } from '~/constants/default.constants'
import { type ISidebarMenu } from '~/types/sidebar-menu.type'

export const APTOS_SIDEBAR: ISidebarMenu[] = [
  {
    icon: 'home',
    label: 'Home',
    value: '',
  },
  {
    icon: 'summarize',
    label: 'Profile',
    value: 'profile',
    children: [
      {
        label: CHAIN,
        value: 'project',
      },
      {
        label: UNIT,
        value: 'token',
      },
    ]
  },
  {
    icon: 'menu_book',
    label: 'Contents',
    value: 'content',
  },
  // {
  //   icon: 'token',
  //   label: 'Ecosystem',
  //   value: 'ecosystem',
  // },
  {
    icon: 'token',
    label: 'DeFi Dashboard',
    value: 'defi-dashboard',
  },
  // {
  //   icon: 'insert_chart',
  //   label: 'On-Chain',
  //   value: 'on-chain',
  //   children: [
  //     {
  //       label: 'Analytics',
  //       value: 'analytics',
  //     },
  //     {
  //       label: 'Compare',
  //       value: 'compare',
  //       isExternalLink: true,
  //       externalLink: 'https://xangle.io/en/assets/APT/analytics/indicator?tab=token',
  //     },
  //     {
  //       label: 'Explorer',
  //       value: 'explorer',
  //       isExternalLink: true,
  //       externalLink: import.meta.env.VITE_APP_EXPLORER_URL,
  //     }
  //   ]
  // },
  // {
  //   icon: 'donut_small',
  //   label: 'Circulating Supply',
  //   value: 'circulating-supply',
  // },
  {
    image: 'https://globalstatic.xangle.io/svg/xangle.svg',
    // label: 'Xangle Portal',
    // value: 'xangle-portal',
    label: 'Aptos Explorer',
    value: 'aptos-explorer',
    isExternalLink: true,
    externalLink: import.meta.env.VITE_APP_EXPLORER_URL,
  }
]